import { Component, inject, Input, OnInit, DestroyRef, signal } from "@angular/core";
import { WhiteLabelConfigService } from "../../../../../../../../../shared/src/lib/services/white-label-config.service";
import { Market } from "../../../../../../../../../shared/src/lib/types/bet.type";
import { DecimalPipe } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-bet-config",
  imports: [DecimalPipe],
  templateUrl: "./bet-config.component.html",
  styleUrl: "./bet-config.component.scss",
})
export class BetConfigComponent implements OnInit {
  @Input({ required: true }) market!: Market;
  whitelabelConfig = inject(WhiteLabelConfigService);
  private readonly destroyRef = inject(DestroyRef);

  maxBetSize = signal<number | null>(null);
  minBetSize = signal<number | null>(null);

  ngOnInit() {
    this.whitelabelConfig.betConfig$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((betConfig) => {
      const sportId = this.market?.eventType?.id;
      if (betConfig && sportId && betConfig[sportId]) {
        this.minBetSize.set(betConfig[sportId].min_bet_size || null);
        this.maxBetSize.set(betConfig[sportId].max_bet_size || null);
      } else {
        this.minBetSize.set(null);
        this.maxBetSize.set(null);
      }
    });
  }
}
